import { UserPayload } from "../models/SiteModel";
import { apiFetch } from "./fetchService";

const URLAPI = process.env.REACT_APP_BASE_URL;

export interface ProductosConfigListas {
  relacionListas: string;
  nombreListas: string;
  margenContado: string;
  margenMayorista: string;
  margenMinorista: string;
  decimalesEnCantidad: number;
  conMesas: boolean;
  controlesCuentaCorrienteActivos: boolean;
}

export async function fetchAppConfig(user: UserPayload, idLocal?: number, pv?: number): Promise<ProductosConfigListas | undefined> {
  const params = new URLSearchParams();
  if (idLocal && pv) {
    params.set("idLocal", String(idLocal));
    params.set("pv", String(pv));
  }
  const query = params.toString();
  const data = await apiFetch(user.token, `${URLAPI}/Config${query ? `?${query}` : ""}`);
  if (!data) {
    return undefined;
  }

  return {
    relacionListas: data.relacionListas ?? data.RelacionListas ?? "",
    nombreListas: data.nombreListas ?? data.NombreListas ?? "",
    margenContado: data.margenContado ?? data.MargenContado ?? "",
    margenMayorista: data.margenMayorista ?? data.MargenMayorista ?? "",
    margenMinorista: data.margenMinorista ?? data.MargenMinorista ?? "",
    decimalesEnCantidad: Number(data.decimalesEnCantidad ?? data.DecimalesEnCantidad ?? 2),
    conMesas: Boolean(data.conMesas ?? data.ConMesas ?? false),
    controlesCuentaCorrienteActivos: Boolean(
      data.controlesCuentaCorrienteActivos ?? data.ControlesCuentaCorrienteActivos ?? false
    )
  };
}
